<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar class="custom-toolbar">
        <ion-buttons slot="start">
          <ion-menu-button color="light"></ion-menu-button>
        </ion-buttons>
        <ion-title class="custom-title">Jahaji Workspace</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true" class="home-content">
      <div class="home-container">
        
        <!-- Welcome Banner Card -->
        <div class="welcome-banner">
          <div class="banner-glow"></div>
          <div class="banner-info">
            <span class="greeting">WELCOME BACK,</span>
            <h1 class="user-display-name">{{ displayName }}</h1>
            <p class="today-date">{{ formattedDate }}</p>
          </div>
        </div>

        <!-- IOU Balance Card -->
        <div class="iou-widget">
          <div class="iou-accent"></div>
          <div class="iou-header-row">
            <div class="iou-icon-wrapper">
              <ion-icon :icon="walletOutline" class="iou-icon"></ion-icon>
            </div>
            <span class="iou-label">IOU Balance</span>
          </div>
          <div class="iou-amount">
            <span class="currency">৳</span>
            <span class="amount">{{ formatCurrency(iou) }}</span>
          </div>
          <p class="iou-sub">Current outstanding cash requisition balance</p>
        </div>

        <!-- Quick Access Bento Grid -->
        <div class="quick-access-section">
          <h3 class="section-title">Quick Actions</h3>
          <div class="bento-grid">
            <div class="bento-item attendance" @click="navigate('/hr/attendance')">
              <div class="item-icon-wrapper bg-green">
                <ion-icon :icon="timeOutline"></ion-icon>
              </div>
              <span class="item-title">Attendance</span>
              <span class="item-desc">Clock In/Out</span>
            </div>

            <div class="bento-item apply-leave" @click="navigate('/hr/leave-apply')">
              <div class="item-icon-wrapper bg-blue">
                <ion-icon :icon="calendarOutline"></ion-icon>
              </div>
              <span class="item-title">Apply Leave</span>
              <span class="item-desc">Request Time Off</span>
            </div>

            <div class="bento-item my-leaves" @click="navigate('/hr/my-leaves')">
              <div class="item-icon-wrapper bg-orange">
                <ion-icon :icon="briefcaseOutline"></ion-icon>
              </div>
              <span class="item-title">My Leaves</span>
              <span class="item-desc">Track Requests</span>
            </div>

            <div class="bento-item report" @click="navigate('/hr/attendance-report')">
              <div class="item-icon-wrapper bg-teal">
                <ion-icon :icon="documentTextOutline"></ion-icon>
              </div>
              <span class="item-title">History Report</span>
              <span class="item-desc">View Monthly Logs</span>
            </div>

            <div v-if="isAdmin" class="bento-item team-daily" @click="navigate('/hr/team-daily')">
              <div class="item-icon-wrapper" style="background-color: var(--ion-color-secondary);">
                <ion-icon :icon="peopleOutline"></ion-icon>
              </div>
              <span class="item-title">Team Daily</span>
              <span class="item-desc">Admin Overview</span>
            </div>
          </div>
        </div>

        <!-- Brand Footer -->
        <div class="brand-footer">
          <div class="logo-wrapper">
            <img src="assets/icon/logo.png" class="brand-logo" alt="Jahaji Logo" />
          </div>
          <span class="app-version">Version 1.0.0 (Inhouse)</span>
        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<script>
/* eslint-disable */
import { 
  IonButtons, 
  IonContent, 
  IonHeader, 
  IonMenuButton, 
  IonPage, 
  IonTitle, 
  IonToolbar, 
  IonIcon,
  useBackButton, 
  useIonRouter 
} from '@ionic/vue';
import { 
  walletOutline, 
  timeOutline, 
  calendarOutline, 
  briefcaseOutline, 
  documentTextOutline,
  peopleOutline
} from 'ionicons/icons';
import { Plugins } from "@capacitor/core";
const { App } = Plugins;

export default {
  name: 'Home',
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonIcon
  },
  data() {
    return {
      iou: 0,
      exitCount: 0,
      walletOutline,
      timeOutline,
      calendarOutline,
      briefcaseOutline,
      documentTextOutline,
      peopleOutline
    }
  },
  computed: {
    // Check if the logged-in user is an admin to selectively render the Team Daily report UI
    isAdmin() {
      const type = window.localStorage.getItem('user_type');
      return type === 'admin' || type === 'entry';
    },
    displayName() {
      return window.localStorage.name || 'Jahaji Member';
    },
    formattedDate() {
      const now = new Date();
      return now.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
    }
  },
  created() {
    this.exitCount = 0;
    const ionRouter = useIonRouter();
    useBackButton(-1, () => {
      this.exitCount++;
      if (this.$route.name == "home" && this.exitCount == 2) {
        App.exitApp();
      }
    });
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
      };
      this.$http.post('getAuthUser', data)
        .then(response => {
          this.iou = response.data.iou;
        })
        .catch(err => {
          console.error(err);
        });
    },
    navigate(route) {
      this.$router.push(route);
    },
    formatCurrency(val) {
      const num = parseFloat(val);
      return isNaN(num) ? '0' : num.toLocaleString('en-US');
    }
  }
}
</script>

<style scoped>
/* Core Styles */
.home-content {
  --background: #f4f6fc;
}

.home-container {
  padding: 16px;
  max-width: 600px;
  margin: 0 auto;
}

/* Custom Toolbar Styles */
.custom-toolbar {
  --background: linear-gradient(135deg, #102a43 0%, #243b53 100%);
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.custom-title {
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: 0.5px;
}

/* Welcome Banner Card */
.welcome-banner {
  position: relative;
  background: linear-gradient(135deg, #102a43 0%, #243b53 100%);
  border-radius: 20px;
  padding: 24px;
  color: #ffffff;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(16, 42, 67, 0.15);
  margin-bottom: 16px;
}

.banner-glow {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(96, 165, 250, 0.25) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
}

.banner-info {
  position: relative;
  z-index: 1;
}

.greeting {
  font-size: 0.65rem;
  font-weight: 700;
  color: #93c5fd;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.user-display-name {
  margin: 4px 0 6px 0;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: 0.3px;
}

.today-date {
  margin: 0;
  font-size: 0.8rem;
  color: #94a3b8;
  font-weight: 500;
}

/* IOU Widget */
.iou-widget {
  position: relative;
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(16, 42, 67, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.02);
  margin-bottom: 24px;
  overflow: hidden;
}

.iou-accent {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 5px;
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
}

.iou-header-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.iou-icon-wrapper {
  background: #ecfdf5;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iou-icon {
  color: #10b981;
  font-size: 1.15rem;
}

.iou-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.iou-amount {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 4px;
}

.currency {
  font-size: 1.4rem;
  font-weight: 800;
  color: #102a43;
}

.amount {
  font-size: 2.1rem;
  font-weight: 800;
  color: #102a43;
  letter-spacing: -0.5px;
}

.iou-sub {
  margin: 0;
  font-size: 0.72rem;
  color: #829ab1;
  font-weight: 600;
}

/* Quick Access Bento Grid */
.quick-access-section {
  margin-bottom: 24px;
}

.section-title {
  margin: 0 0 12px 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #102a43;
  letter-spacing: 0.3px;
}

.bento-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.bento-item {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.02);
  border-radius: 18px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 20px rgba(16, 42, 67, 0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.bento-item:active {
  transform: scale(0.96);
  box-shadow: 0 4px 10px rgba(16, 42, 67, 0.02);
}

.item-icon-wrapper {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.item-icon-wrapper ion-icon {
  font-size: 1.25rem;
}

.bg-green { background: #ecfdf5; color: #10b981; }
.bg-blue { background: #eff6ff; color: #3b82f6; }
.bg-orange { background: #fffbeb; color: #f59e0b; }
.bg-teal { background: #f0fdfa; color: #0d9488; }

.item-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 2px;
}

.item-desc {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 500;
}

/* Brand Footer */
.brand-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 36px;
  margin-bottom: 20px;
}

.logo-wrapper {
  background: #ffffff;
  padding: 12px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo {
  height: 48px;
  object-fit: contain;
}

.app-version {
  font-size: 0.68rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>